import get from "lodash/get";

export const helpPageUrl = "/gp/help/external/GWYBC38TZGCUNRKW";

export const SELECT_YOUR_PROGRAM = "SELECT_YOUR_PROGRAM";
export const PROGRAM_NAME_OF_FBA = "Core";
export const PROGRAM_NAME_OF_MFN = "MFN";
export const defaultPrograms = [PROGRAM_NAME_OF_FBA, PROGRAM_NAME_OF_MFN];

export const programNotesMap: Record<string, string> = {
    "NARF": "SC_FBA_Calc_program_narf_notes",
    "Core": "SC_FBA_Calc_program_fba_notes",
    "Uno": "SC_FBA_Calc_program_snl_notes",
    "EFN": "SC_FBA_Calc_program_efn_notes",
    "PanEU": "SC_FBA_Calc_program_paneu_notes",
    "PanEUUno": "SC_FBA_Calc_program_paneusnl_notes"
}

export const programNameMap: Record<string, string> = {
    "NARF": "SC_FBA_Calc_program_narf",
    "Core": "SC_FBA_Calc_AMZNFulfillment",
    "Uno": "SC_FBA_Calc_program_snl",
    "EFN": "SC_FBA_Calc_program_efn",
    "PanEU": "SC_FBA_Calc_program_paneu",
    "PanEUUno": "SC_FBA_Calc_program_paneusnl",
    "MFN": "SC_FBA_Calc_yourFulfillment"
}

export const programBenefitsMap: Record<string, Array<string>> = {
    "NARF": [
        "SC_FBA_Calc_program_narf_benefits1",
        "SC_FBA_Calc_program_narf_benefits2",
        "SC_FBA_Calc_program_narf_benefits3"
    ],
    "Core": [
        "SC_FBA_Calc_program_fba_benefits1",
        "SC_FBA_Calc_program_fba_benefits2",
        "SC_FBA_Calc_program_fba_benefits3",
        "SC_FBA_Calc_program_fba_benefits4"
    ],
    "Uno": [
        "SC_FBA_Calc_program_snl_benefits1",
        "SC_FBA_Calc_program_snl_benefits2",
        "SC_FBA_Calc_program_snl_benefits3"
    ],
    "EFN": [
        "SC_FBA_Calc_program_efn_benefits1",
        "SC_FBA_Calc_program_efn_benefits2"
    ],
    "PanEU": [
        "SC_FBA_Calc_program_paneu_benefits1",
        "SC_FBA_Calc_program_paneu_benefits2",
        "SC_FBA_Calc_program_paneu_benefits3",
    ],
    "PanEUUno": [
        "SC_FBA_Calc_program_paneusnl_benefits1",
        "SC_FBA_Calc_program_paneusnl_benefits2",
        "SC_FBA_Calc_program_paneusnl_benefits3",
        "SC_FBA_Calc_program_paneusnl_benefits4"
    ]
}
export const loginProgramHelpLinkMap: Record<string, Record<string, string>> = {
    "Uno": {
        "GB": "https://sellercentral.amazon.co.uk/fba/programs/snl/about",
        "DE": "https://sellercentral.amazon.de/fba/programs/snl/about",
        "FR": "https://sellercentral.amazon.fr/fba/programs/snl/about",
        "IT": "https://sellercentral.amazon.it/fba/programs/snl/about",
        "ES": "https://sellercentral.amazon.es/fba/programs/snl/about",
        "JP": "https://sellercentral.amazon.co.jp/fba/programs/snl/about",
        "US": "https://sellercentral.amazon.com/fba/programs/snl/about"
    },
    "PanEUUno": {
        "GB": "https://sellercentral.amazon.co.uk/fba/programs/snl/paneu",
        "DE": "https://sellercentral.amazon.de/fba/programs/snl/paneu",
        "FR": "https://sellercentral.amazon.fr/fba/programs/snl/paneu",
        "IT": "https://sellercentral.amazon.it/fba/programs/snl/paneu",
        "ES": "https://sellercentral.amazon.es/fba/programs/snl/paneu"
    },
    "PanEU": {
        "ALL": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe"
    },
    "MFN": {
        "ALL": "https://sell.amazon.com/learn/ecommerce-fulfillment"
    },
    "Core": {
        "ALL": "https://sell.amazon.com/fulfillment-by-amazon"
    },
    "CEE": {
        "DE": "https://sellercentral-europe.amazon.com/help/hub/reference/G202030150"
    },
    "NARF": {
        "ALL": "https://sellercentral.amazon.com/gp/help/help.html?itemID=G5P3CDUHZWSZLXLB"
    },
    "EFN": {
        "ALL": "https://sellercentral.amazon.co.uk/gp/help/external/201606080"
    }
}

export const nonLoginProgramHelpLinkMap: Record<string, Record<string, string>> = {
    "Uno": {
        "GB": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-small-and-light",
        "DE": "https://sell.amazon.de/versand-durch-amazon/small-and-light",
        "FR": "https://sell.amazon.fr/expedie-par-amazon/petit-et-leger",
        "IT": "https://sell.amazon.it/logistica-di-amazon/small-and-light",
        "ES": "https://sell.amazon.es/logistica-de-amazon/pequeno-y-ligero",
        "JP": "https://sell.amazon.co.jp/fulfill/fulfillment-by-amazon/small-and-light?ref_=asjp_soa_rd&",
        "US": "https://sell.amazon.com/fulfillment-by-amazon/fba-small-and-light"
    },
    "PanEUUno": {
        "GB": "https://sell.amazon.com/fulfillment-by-amazon",
        "DE": "https://sell.amazon.com/fulfillment-by-amazon",
        "FR": "https://sell.amazon.com/fulfillment-by-amazon",
        "IT": "https://sell.amazon.com/fulfillment-by-amazon",
        "ES": "https://sell.amazon.com/fulfillment-by-amazon"
    },
    "PanEU": {
        "DE": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe",
        "FR": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe",
        "IT": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe",
        "ES": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe"
    },
    "MFN": {
        "ALL": "https://sell.amazon.com/learn/ecommerce-fulfillment"
    },
    "Core": {
        "ALL": "https://sell.amazon.com/fulfillment-by-amazon"
    },
    "CEE": {
        "DE": "https://sell.amazon.de/versand-durch-amazon/central-europe-program "
    },
    "NARF": {
        "ALL": "https://sellercentral.amazon.com/gp/help/help.html?itemID=G5P3CDUHZWSZLXLB"
    },
    "EFN": {
        "ALL": "https://sellercentral.amazon.co.uk/gp/help/external/201606080"
    }
}

export const RECOMMENDATION_FBA = "FBA_CREATE_SHIPMENT";
export const RECOMMENDATION_LOWASP = "LOW_ASP_DISCOUNT";

export const programWithInventoryAndStoreParam: Array<string> = [
    "NARF",
    "EFN",
    "EFN_CEE",
    "EFNUno",
    "EFNUno_CEE",
    "PanEU",
    "PanEU_CEE",
    "PanEUUno",
    "PanEUUno_CEE",
    "EURF",
    "EURF_CEE",
    "EURFUno",
    "EURFUno_CEE"
]

export const programWithCeeParam: Array<string> = [
    "Uno",
    "EFN",
    "EFN_CEE",
    "EFNUno",
    "EFNUno_CEE",
    "PanEU",
    "PanEU_CEE",
    "PanEUUno",
    "PanEUUno_CEE",
    "EURF",
    "EURF_CEE",
    "EURFUno",
    "EURFUno_CEE"
]

export const isLoginMap: Record<string, boolean> = {
    "true": true,
    "false": false
}

export function isLoginMode(): boolean {
    return isLoginMap["false"]!;
}

export const isSurchargeMarketplaceMap: Record<string, boolean> = {
    "US": true,
    "GB": true,
    "DE": true,
    "FR": true,
    "IT": true,
    "ES": true,
    "CA": true
}

export const surchargeBannerStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Fuel_Surcharge_Banner",
    "GB": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "DE": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "FR": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "IT": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "ES": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "CA": "2022_CA_Referral_Fee_and_FBA_Fee_Change"
}

export const surchargeDateStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Fuel_Surcharge_Banner_4282022_Date",
    "GB": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "DE": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "FR": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "IT": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "ES": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date"
}

export const surchargeRateMap: Record<string, number> = {
    "US": 0.05,
    "GB": 0.043,
    "DE": 0.043,
    "FR": 0.043,
    "IT": 0.043,
    "ES": 0.043
}

export const surchargeHelpPageLinkStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link",
    "GB": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "DE": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "FR": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "IT": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "ES": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "CA": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_CA"
}

export const surchargeHelpPageLinkMap: Record<string, string> = {
    "US": "https://sellercentral.amazon.com/help/hub/reference/GABBX6GZPA8MSZGW?ref_=revecalc",
    "GB": "https://sellercentral.amazon.co.uk/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "DE": "https://sellercentral.amazon.de/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "FR": "https://sellercentral.amazon.fr/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "IT": "https://sellercentral.amazon.it/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "ES": "https://sellercentral.amazon.es/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "CA": "https://sellercentral.amazon.ca/help/hub/reference/GABBX6GZPA8MSZGW?ref_=revecalc"
}

export const countryMap: Record<string, Array<string>> = {
    "USAmazon": [
        "US",
        "CA",
        "MX",
        "BR"
    ],
    "EUAmazon": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "IN",
        "AE",
        "TR",
        "SA",
        "NL",
        "SE",
        "PL",
        "EG",
        "BE",
    ],
    "JPAmazon": [
        "JP",
        "AU",
        "SG"
    ]
};

export const programAmazonStoreMap: Record<string, Array<string>> = {
    "NARF": [
        "CA",
        "MX"
    ],
    "EFN": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "BE",
    ],
    "PanEU": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "BE",
    ],
    "EFNUno": [
        "DE",
        "FR",
        "IT",
        "ES",
    ],
    "PanEUUno": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
    ]
};

export const programInventoryMap: Record<string, Array<string>> = {
    "NARF": [
        "US"
    ],
    "EFN": [
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "CZ",
        "BE",
        "GB",
    ],
    "PanEU": [
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "CZ",
        "BE",
        "GB",
    ],
    "EFNUno": [
        "DE",
        "FR",
        "IT",
        "ES",
        "PL",
        "CZ",
    ],
    "PanEUUno": [
        "DE",
        "FR",
        "IT",
        "ES",
        "PL",
        "CZ",
        "GB",
    ]
};

export const countryFBAProgramRankMap: Record<string, Record<string, number>> = {
    "US": {
        "Uno": 1,
        "Core": 2
    },
    "CA": {
        "Core": 1
    },
    "MX": {
        "Core": 1
    },
    "BR": {
        "Core": 1
    },
    "GB": {
        "Uno": 1,
        "Core": 2
    },
    "DE": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "FR": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "IT": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "ES": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "NL": {
        "PanEU": 1,
        "Core": 2
    },
    "PL": {
        "PanEU": 1,
        "Core": 2
    },
    "SE": {
        "PanEU": 1,
        "Core": 2
    },
    "BE": {
        "PanEU": 1,
        "Core": 2
    },
    "TR": {
        "Core": 1
    },
    "IN": {
        "Core": 1
    },
    "JP": {
        "Uno": 1,
        "Core": 2
    },
    "AE": {
        "Core": 1
    },
    "SA": {
        "Core": 1
    },
    "EG": {
        "Core": 1
    },
    "AU": {
        "Core": 1
    },
    "SG": {
        "Core": 1
    }
};
export const countryProgramList: Record<string, Array<string>> = {
    "US": ["MFN", "Core", "Uno"],
    "CA": ["MFN", "Core", "NARF"],
    "MX": ["MFN", "Core", "NARF"],
    "BR": ["MFN", "Core"],
    "GB": ["MFN", "Core", "EFN", "PanEU", "Uno", "PanEUUno"],
    "DE": ["MFN", "Core", "EFN", "PanEU", "Uno", "PanEUUno"],
    "FR": ["MFN", "Core", "EFN", "PanEU", "Uno", "PanEUUno"],
    "IT": ["MFN", "Core", "EFN", "PanEU", "Uno", "PanEUUno"],
    "ES": ["MFN", "Core", "EFN", "PanEU", "Uno", "PanEUUno"],
    "IN": ["MFN", "Core"],
    "AE": ["MFN", "Core"],
    "TR": ["MFN", "Core"],
    "SA": ["MFN", "Core"],
    "NL": ["MFN", "Core", "EFN", "PanEU"],
    "SE": ["MFN", "Core", "EFN", "PanEU"],
    "PL": ["MFN", "Core", "EFN", "PanEU"],
    "EG": ["MFN", "Core"],
    "BE": ["MFN", "Core", "EFN", "PanEU"],
    "JP": ["MFN", "Core", "Uno"],
    "AU": ["MFN", "Core"],
    "SG": ["MFN", "Core"],
}

export const bulkProgramName: Record<string, Array<string>> = {
    "Core": ["SC_FBA_Calc_AMZNFulfillment"],
    "MFN": ["SC_FBA_Calc_yourFulfillment"],
    "NARF": ["SC_FBA_Calc_program_narf"],
    "Uno": ["SC_FBA_Calc_program_snl"],
    "EFN": ["SC_FBA_Calc_program_efn"],
    "PanEU": ["SC_FBA_Calc_program_paneu"],
    "PanEUUno": ["SC_FBA_Calc_program_paneusnl"],
}

export function hasRecommendationRank(countryCode: string, programName: string): boolean {
    return countryFBAProgramRankMap[countryCode] && countryFBAProgramRankMap[countryCode][programName] != undefined;
}

export function getRecommendationRank(countryCode: string, programName: string): number {
    return countryFBAProgramRankMap[countryCode][programName];
}

export const sellerCentralFeedbackHMDIdMap: Record<string, Record<string, string>> = {
    "test": {
        "USAmazon": "20111738uSeYKMXS3ijwR7OOskqRw",
        "EUAmazon": "2011200u/7iLbEfR2yHeHRnNp9h4w",
        "JPAmazon": "2011200oaLeCiB9QICXgHiyNRbAaQ"
    },
    "master": {
        "USAmazon": "2011193sHIexo8qTQqQXv5AljWENQ",
        "EUAmazon": "2011200kWRZ77ZJSzaHk8ZD350FMA",
        "JPAmazon": "2011200sSqxx+bfSQKIMnbH7G2htA"
    },
    "prod": {
        "USAmazon": "2011193sHIexo8qTQqQXv5AljWENQ",
        "EUAmazon": "2011200kWRZ77ZJSzaHk8ZD350FMA",
        "JPAmazon": "2011200sSqxx+bfSQKIMnbH7G2htA"
    }
};

export const countryDimensionUnitAbbrMap: Record<string, string> = {
    "US": "in"
};

export const dimensionUnitAbbrMap: Record<string, string> = {
    "in": "inches",
    "cm": "centimeters"
};

export const countryWeightUnitAbbrMap: Record<string, string> = {
    "US": "lb"
};

export const countryWeightUnitMap: Record<string, string> = {
    "US": "pounds"
};

export const countryCurrencySymbolMap: Record<string, string> = {
    "US": "$",
    "CA": "$",
    "MX": "$",
    "BR": "R$",
    "GB": "£",
    "DE": "€",
    "FR": "€",
    "IT": "€",
    "ES": "€",
    "IN": "₹",
    "AE": "د.إ",
    "TR": "₺",
    "SA": "ر.س",
    "NL": "€",
    "SE": "kr",
    "PL": "zł",
    "EG": "£",
    "BE": "€",
    "JP": "¥",
    "AU": "$",
    "SG": "$",
};

export const countryCurrencyUnitMap: Record<string, string> = {
    "US": "USD",
    "CA": "CAD",
    "MX": "MXN",
    "BR": "BRL",
    "GB": "GBP",
    "DE": "EUR",
    "FR": "EUR",
    "IT": "EUR",
    "ES": "EUR",
    "IN": "INR",
    "AE": "AED",
    "TR": "TRY",
    "SA": "SAR",
    "NL": "EUR",
    "SE": "SEK",
    "PL": "PLN",
    "EG": "EGP",
    "BE": "EUR",
    "JP": "JPY",
    "AU": "AUD",
    "SG": "SGD",
};

export const countryLocaleMap: Record<string, string> = {
    "US": "en_US",
    "CA": "en_CA",
    "MX": "es_MX",
    "BR": "pt_BR",
    "GB": "en_GB",
    "DE": "de_DE",
    "FR": "fr_FR",
    "IT": "it_IT",
    "ES": "es_ES",
    "IN": "en_IN",
    "AE": "en_AE",
    "TR": "tr_TR",
    "SA": "en_SA",
    "NL": "nl_NL",
    "SE": "sv_SE",
    "PL": "pl_PL",
    "EG": "en_EG",
    "BE": "fr_BE",
    "JP": "ja_JP",
    "AU": "en_AU",
    "SG": "en_SG",
};

export const feeHelpPageMap: Record<string, Record<string, string>> = {
    "ReferralFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GTG4BAWSY39Z98Z3?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=H78LW99F4XF3Z38&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GYND54PM5WB84UM&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=F9K4BWLZXRPC62U&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=TM7BFLLKEA8T7C4&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=CZC4GX2L32EKP6F&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=UMBCNJPHD3UV47Q&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=MQ6PTDCN6ZAVA55&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=8DGDDVY6WEJ522N&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=GKYSFTZ5R8JMAHNV&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
    },
    "FixedClosingFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G8TPCFJRDFPKAZ6M?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=H78LW99F4XF3Z38&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GYND54PM5WB84UM&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=F9K4BWLZXRPC62U&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=TM7BFLLKEA8T7C4&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=CZC4GX2L32EKP6F&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=UMBCNJPHD3UV47Q&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=MQ6PTDCN6ZAVA55&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=8DGDDVY6WEJ522N&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=GKYSFTZ5R8JMAHNV&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
    },
    "VariableClosingFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GKD9U5REK5DKB38Y?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G201535680&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=H78LW99F4XF3Z38&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GYND54PM5WB84UM&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=F9K4BWLZXRPC62U&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=TM7BFLLKEA8T7C4&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=CZC4GX2L32EKP6F&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G201115050&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G201115050&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=201631600&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=UMBCNJPHD3UV47Q&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=MQ6PTDCN6ZAVA55&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=8DGDDVY6WEJ522N&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=GKYSFTZ5R8JMAHNV&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
    },
    "FulfillmentFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GPDC3KPYAGDTVDJP?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=201112670&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=201112670&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=201112670&ref_=revecalc",
    },
    "MonthlyStorageFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G3EDYEF6KUCFQTNM?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=200612770&ref_=revecalc",
    },
    "FBAInboundConvenienceFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G200735910?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=G200735910&ref_=revecalc"
    },
    "PrepFees": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G201023020?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G201023020&ref_=revecalc"
    },
}

export const nonLoginFeeHelpPageMap: Record<string, Record<string, string>> = {
    "ReferralFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/GTG4BAWSY39Z98Z3?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200336920?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G200336920?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200336920?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/H78LW99F4XF3Z38?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GYND54PM5WB84UM?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/F9K4BWLZXRPC62U?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/TM7BFLLKEA8T7C4?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/CZC4GX2L32EKP6F?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200336920?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G200336920?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G200336920?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/G200336920?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/UMBCNJPHD3UV47Q?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/MQ6PTDCN6ZAVA55?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/8DGDDVY6WEJ522N?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200336920?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/GKYSFTZ5R8JMAHNV?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G200336920?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G200336920?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G200336920?ref_=revecalc",
    },
    "FixedClosingFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G8TPCFJRDFPKAZ6M?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200336920?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G200336920?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200336920?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/H78LW99F4XF3Z38?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GYND54PM5WB84UM?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/F9K4BWLZXRPC62U?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/TM7BFLLKEA8T7C4?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/CZC4GX2L32EKP6F?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200336920?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G200336920?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G200336920?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/G200336920?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/UMBCNJPHD3UV47Q?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/MQ6PTDCN6ZAVA55?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/8DGDDVY6WEJ522N?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200336920?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/GKYSFTZ5R8JMAHNV?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G200336920?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G200336920?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G200336920?ref_=revecalc",
    },
    "VariableClosingFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/GKD9U5REK5DKB38Y?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200336920?ref_=revecalc",
        "MX": "https://vender.amazon.com.mx/precios?ref_=revecalc#tarifas-por-referencia",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200336920?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/H78LW99F4XF3Z38?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GYND54PM5WB84UM?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/F9K4BWLZXRPC62U?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/TM7BFLLKEA8T7C4?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/CZC4GX2L32EKP6F?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200336920?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G201115050?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G201115050?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/201631600?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/UMBCNJPHD3UV47Q?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/MQ6PTDCN6ZAVA55?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/8DGDDVY6WEJ522N?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200336920?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/GKYSFTZ5R8JMAHNV?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G200336920?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G200336920?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G200336920?ref_=revecalc",
    },
    "FulfillmentFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/GPDC3KPYAGDTVDJP?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200209150?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G200209150?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200209150?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/G200209150?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/G200209150?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/G200209150?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/G200209150?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/G200209150?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200209150?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G200209150?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G200209150?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/G200209150?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/G200209150?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/G200209150?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/G200209150?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200209150?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/G200209150?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/201112670?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/201112670?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/201112670?ref_=revecalc",
    },
    "MonthlyStorageFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G3EDYEF6KUCFQTNM?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/200612770?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/200612770?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/200612770?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/200612770?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/200612770?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/200612770?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/200612770?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/200612770?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/200612770?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/200612770?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/200612770?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/200612770?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/200612770?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/200612770?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/200612770?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/200612770?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/200612770?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/200612770?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/200612770?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/200612770?ref_=revecalc",
    },
    "FBAInboundConvenienceFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G200735910?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc"
    },
    "PrepFees": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G201023020?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G201023020?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G201023020?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/G201023020?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/G201023020?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/G201023020?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/G201023020?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/G201023020?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G201023020?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G201023020?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G201023020?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G201023020?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G201023020?ref_=revecalc"
    }
}

const defaultDimensionUnitAbbr = "cm";
const defaultWeightUnitAbbr = "kg";
const defaultWeightUnit = "kilograms";
const defaultCurrencySymbol = "$";
const defaultCurrencyUnit = "USD";
const defaultLocale = "en_US";

const defaultCountryList = countryMap["USAmazon"];

export function getCountryListConfig(): Array<string> {
    return get(countryMap, "USAmazon", defaultCountryList);
}

export function getProgramStoreCountryListConfig(program: string): Array<string> {
    return get(programAmazonStoreMap, program, defaultCountryList);
}

export function getProgramInventoryCountryListConfig(program: string): Array<string> {
    return get(programInventoryMap, program, defaultCountryList);
}

export function getHMDId(): string {
    return sellerCentralFeedbackHMDIdMap["prod"]!["USAmazon"]!;
}

export function getProgramBenfit(program: string): Array<string> {
    return get(programBenefitsMap, program, []);
}

export function getProgramName(program: string): string {
    return get(programNameMap, program, "");
}

export function getDimensionUnitListConfig(): Array<string> {
    return [
        "in",
        "cm"
    ];
}

export function getDimensionUnitAbbrConfig(countryCode: string): string {
    return get(countryDimensionUnitAbbrMap, countryCode, defaultDimensionUnitAbbr);
}

export function getWeightUnitAbbrConfig(countryCode: string): string {
    return get(countryWeightUnitAbbrMap, countryCode, defaultWeightUnitAbbr);
}

export function getWeightUnitConfig(countryCode: string): string {
    return get(countryWeightUnitMap, countryCode, defaultWeightUnit);
}

export function getCurrencySymbolConfig(countryCode: string): string {
    return get(countryCurrencySymbolMap, countryCode, defaultCurrencySymbol);
}

export function getCurrencyUnitConfig(countryCode: string): string {
    return get(countryCurrencyUnitMap, countryCode, defaultCurrencyUnit);
}

export function getLocaleConfig(countryCode: string): string {
    return get(countryLocaleMap, countryCode, defaultLocale);
}

export function getHelpPageLink(countryCode: string, feeTypeName: string): string {
    if (isLoginMode()) {
        return get(feeHelpPageMap[feeTypeName], countryCode, "/gp/help?ref_=referral");
    }
    return get(nonLoginFeeHelpPageMap[feeTypeName], countryCode, "/gp/help/external?ref_=referral");
}

export function getProgramLink(program: string, marketplace: string): string {
    if (isLoginMode()) {
        const defaultLink = get(loginProgramHelpLinkMap[program], "ALL", "")
        return get(loginProgramHelpLinkMap[program], marketplace, defaultLink);

    } else {
        const defaultLink = get(nonLoginProgramHelpLinkMap[program], "ALL", "")
        return get(nonLoginProgramHelpLinkMap[program], marketplace, defaultLink);
    }
}

export const countryCategoryTRexIdMap: Record<string, Record<number, string>> = {
    "US": {
        10001: "FS-ProductCategory-gl-digital-accessories-10-FullName",
        10031: "FS-ProductCategory-automotive-FullName",
        10003: "FS-FeeCategory-babyproducts-FullName",
        10032: "FS-ProductCategory-beauty-FullName",
        10004: "FS-FeeCategory-mediabooksdvdmusicsoftwarevideo-FullName",
        10033: "FS-ProductCategory-apparel-FullName",
        10035: "FS-ProductCategory-coinscollectibles-FullName",
        10007: "FS-ProductCategory-electronicsbasedevices-us-FullName",
        10026: "FS-ProductCategory-dvd-FullName",
        10008: "FS-FeeCategory-electronicaccessories-FullName",
        10036: "FS-ProductCategory-entertainmentcollectibles-FullName",
        10037: "FS-ProductCategory-art-FullName",
        10009: "FS-FeeCategory-mattresses-FullName",
        10010: "FS-FeeCategory-furniture-FullName",
        10038: "FS-ProductCategory-consumablesphysicalgiftcards-FullName",
        10039: "FS-FeeCategory-groceryandgourmet-FullName",
        10040: "FS-FeeCategory-healthandpersonalcare-FullName",
        10011: "FS-FeeCategory-lawnandgarden-FullName",
        10041: "FS-FeeCategory-businessindustrialandscientificsupplies-FullName",
        10042: "FS-ProductCategory-jewelry-FullName",
        10012: "FS-FeeCategory-homeandkitchen-FullName",
        10043: "FS-FeeCategory-backpackshandbagsandluggage-FullName",
        10013: "FS-FeeCategory-compactappliances-FullName",
        10014: "FS-ProductCategory-music-FullName",
        10015: "FS-FeeCategory-musicalinstrumentsandavproduction-FullName",
        10016: "FS-ProductCategory-officesuppliesbasedevices-us-FullName",
        10017: "FS-ProductCategory-outdoors-FullName",
        10018: "FS-FeeCategory-computers-FullName",
        10044: "FS-FeeCategory-footwear-FullName",
        10019: "FS-FeeCategory-videogamesandgamingaccessories-FullName",
        10020: "FS-FeeCategory-sportsandoutdoors-FullName",
        10045: "FS-ProductCategory-sportsmemorabilia-FullName",
        10030: "FS-FeeCategory-tires-FullName",
        10022: "FS-ProductCategory-homeimprovement-FullName",
        10021: "FS-FeeCategory-baseequipmentpowertools-FullName",
        10024: "FS-ProductCategory-gl-toy-catset-collectible-cards-FullName",
        10023: "FS-ProductCategory-toy-FullName",
        10027: "FS-ProductCategory-catset-video-game-consoles-FullName",
        10046: "FS-ProductCategory-watch-FullName",
        10047: "FS-FeeCategory-fullsizeappliances-FullName",
        10048: "FS-FeeCategory-lawnmowersandsnowthrowers-FullName",
        10049: "FS-FeeCategory-eyewear-FullName",
        10051: "FS-FeeCategory-petproducts-FullName",
    },
    "CA": {
        10301: "FS-ProductCategory-digitalaccessories-FullName",
        10328: "FS-ProductCategory-automotive-FullName",
        10302: "FS-ProductCategory-babyproduct-FullName",
        10329: "FS-ProductCategory-beauty-FullName",
        10303: "FS-ProductCategory-book-FullName",
        10304: "FS-ProductCategory-camera-FullName",
        10330: "FS-ProductCategory-apparel-FullName",
        10307: "FS-ProductCategory-gl-dvd-FullName",
        10306: "FS-ProductCategory-electronics-FullName",
        10308: "FS-ProductCategory-gl-electronics-catset-electronics-accessories-FullName",
        10309: "FS-ProductCategory-furniture-mattresses-FullName",
        10310: "FS-ProductCategory-furniture-FullName",
        10331: "FS-ProductCategory-grocery-FullName",
        10332: "FS-ProductCategory-personalcareappliances-FullName",
        10311: "FS-ProductCategory-home-FullName",
        10312: "FS-ProductCategory-biss-FullName",
        10333: "FS-ProductCategory-jewelry-FullName",
        10334: "FS-ProductCategory-luggage-FullName",
        10335: "FS-ProductCategory-majorappliances-FullName",
        10305: "FS-ProductCategory-mobileelectronics-FullName",
        10313: "FS-ProductCategory-music-FullName",
        10314: "FS-ProductCategory-musicalinstruments-FullName",
        10315: "FS-ProductCategory-officeproduct-FullName",
        10316: "FS-ProductCategory-electronics-pcbasedevice-ca-FullName",
        10336: "FS-ProductCategory-shoes-FullName",
        10317: "FS-ProductCategory-gl-software-FullName",
        10318: "FS-ProductCategory-sports-FullName",
        10337: "FS-ProductCategory-sportsmemorabilia-FullName",
        10327: "FS-ProductCategory-gl-tires-FullName",
        10319: "FS-ProductCategory-powertoolsbasedevices-ca-FullName",
        10320: "FS-ProductCategory-homeimprovement-FullName",
        10322: "FS-ProductCategory-gl-toy-catset-collectible-cards-FullName",
        10321: "FS-ProductCategory-toy-FullName",
        10325: "FS-ProductCategory-gl-video-FullName",
        10323: "FS-ProductCategory-catset-video-game-consoles-FullName",
        10324: "FS-ProductCategory-gl-videogames-FullName",
        10338: "FS-ProductCategory-watch-FullName",
    },
    "MX": {
        10604: "FS-ProductCategory-gl-electronics-catset-electronics-accessories-FullName",
        10624: "FS-ProductCategory-gl-digital-accessories-10-FullName",
        10614: "FS-ProductCategory-outdoors-FullName",
        10623: "FS-ProductCategory-guild-FullName",
        10627: "FS-ProductCategory-automotive-FullName",
        10626: "FS-ProductCategory-tires-FullName",
        10601: "FS-ProductCategory-babyproduct-FullName",
        10628: "FS-ProductCategory-beauty-FullName",
        10610: "FS-ProductCategory-kitchen-FullName",
        10606: "FS-ProductCategory-grocery-FullName",
        10615: "FS-ProductCategory-pc-FullName",
        10602: "FS-ProductCategory-camera-FullName",
        10617: "FS-ProductCategory-sports-FullName",
        10611: "FS-ProductCategory-majorappliances-FullName",
        10603: "FS-ProductCategory-electronics-FullName",
        10618: "FS-ProductCategory-gl-tools-FullName",
        10636: "FS-ProductCategory-tools-powertools-mx-FullName",
        10607: "FS-ProductCategory-home-FullName",
        10616: "FS-ProductCategory-petproducts-FullName",
        10635: "FS-ProductCategory-biss-FullName",
        10612: "FS-ProductCategory-musicalinstruments-FullName",
        10634: "FS-ProductCategory-jewelry-FullName",
        10619: "FS-ProductCategory-toy-FullName",
        10632: "FS-ProductCategory-luggage-FullName",
        10613: "FS-ProductCategory-officeproduct-FullName",
        10609: "FS-ProductCategory-gl-homeimprovement-FullName",
        10605: "FS-ProductCategory-furniture-FullName",
        10633: "FS-ProductCategory-watch-FullName",
        10631: "FS-ProductCategory-apparel-FullName",
        10630: "FS-ProductCategory-personalcareappliances-FullName",
        10622: "FS-ProductCategory-videogames-FullName",
        10620: "FS-ProductCategory-wireless-FullName",
        10608: "FS-ProductCategory-gl-home-entertainment-FullName",
        10625: "FS-ProductCategory-videogames-consoles-mx-FullName",
        10629: "FS-ProductCategory-wine-jp-FullName",
    },
    "BR": {
        10910: "FS-ProductCategory-gl-pc-catset-electronics-accessories-FullName",
        10925: "FS-ProductCategory-gl-personalcareappliances-FullName",
        10920: "FS-ProductCategory-luggage-FullName",
        10905: "FS-ProductCategory-beauty-FullName",
        10931: "FS-ProductCategory-toy-FullName",
        10903: "FS-ProductCategory-automotive-FullName",
        10916: "FS-ProductCategory-gl-home-FullName",
        10918: "FS-ProductCategory-kitchen-FullName",
        10907: "FS-ProductCategory-camera-FullName",
        10933: "FS-ProductCategory-dvd-FullName",
        10921: "FS-ProductCategory-majorappliances-FullName",
        10928: "FS-ProductCategory-sports-FullName",
        10930: "FS-ProductCategory-homeimprovement-FullName",
        10917: "FS-ProductCategory-jewelry-FullName",
        10906: "FS-ProductCategory-book-FullName",
        10912: "FS-ProductCategory-furniture-FullName",
        10922: "FS-ProductCategory-music-FullName",
        10924: "FS-ProductCategory-pc-FullName",
        10929: "FS-ProductCategory-gl-automotive-catset-tires-FullName",
        10911: "FS-ProductCategory-electronics-FullName",
        10914: "FS-ProductCategory-grocery-FullName",
        10926: "FS-ProductCategory-gl-petsupplies-FullName",
        10904: "FS-ProductCategory-babyproduct-FullName",
        10923: "FS-ProductCategory-officeproduct-FullName",
        10934: "FS-ProductCategory-watch-FullName",
        10909: "FS-ProductCategory-apparel-FullName",
        10927: "FS-ProductCategory-shoes-FullName",
        10915: "FS-ProductCategory-gl-healthandpersonalcare-FullName",
        10913: "FS-ProductCategory-videogames-FullName",
        10932: "FS-ProductCategory-gl-home-entertainment-FullName",
        10902: "FS-ProductCategory-wine-jp-FullName",
        10908: "FS-ProductCategory-wireless-FullName",
    },
    "GB": {
        12101: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        12102: "FS-ProductCategory-digitalaccessories-FullName",
        12110: "FS-ProductCategory-automotive-FullName",
        12103: "FS-ProductCategory-babyproduct-FullName",
        12104: "FS-ProductCategory-beauty-FullName",
        12107: "FS-ProductCategory-biss-FullName",
        12109: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        12108: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        12112: "FS-ProductCategory-apparel-FullName",
        12113: "FS-ProductCategory-gl-pc-catset-electronics-base-devices-FullName",
        12115: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        12144: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        12106: "FS-ProductCategory-dvd-FullName",
        12117: "FS-ProductCategory-bisseducationsupplies-FullName",
        12118: "FS-ProductCategory-electronics-FullName",
        12119: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        12120: "FS-ProductCategory-bissfluidtransfer-FullName",
        12122: "FS-ProductCategory-furniture-mattresses-FullName",
        12123: "FS-ProductCategory-furniture-FullName",
        12124: "FS-ProductCategory-grocery-FullName",
        12142: "FS-ProductCategory-guild-FullName",
        12134: "FS-ProductCategory-personalcareappliances-FullName",
        12127: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        12128: "FS-ProductCategory-bissindustrialtools-FullName",
        12129: "FS-ProductCategory-jewelry-FullName",
        12126: "FS-ProductCategory-kitchen-FullName",
        12130: "FS-ProductCategory-gl-major-appliances-catset-major-appliances-FullName",
        12131: "FS-ProductCategory-bissmaterialhandling-FullName",
        12132: "FS-ProductCategory-bissmetalworking-FullName",
        12133: "FS-ProductCategory-musicalinstruments-FullName",
        12114: "FS-ProductCategory-pc-FullName",
        12135: "FS-ProductCategory-biss-renewableenergysupplies-FullName",
        12136: "FS-ProductCategory-gl-software-FullName",
        12137: "FS-ProductCategory-sports-FullName",
        12116: "FS-ProductCategory-tools-FullName",
        12138: "FS-ProductCategory-tires-FullName",
        12139: "FS-ProductCategory-gl-videogames-FullName",
        12140: "FS-ProductCategory-videogames-consoles-au-FullName",
        12141: "FS-ProductCategory-watch-FullName",
        12105: "FS-ProductCategory-wine-jp-FullName",
    },
    "DE": {
        12401: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        12410: "FS-ProductCategory-automotive-FullName",
        12437: "FS-ProductCategory-tires-FullName",
        12404: "FS-ProductCategory-beauty-FullName",
        12412: "FS-ProductCategory-apparel-FullName",
        12413: "FS-ProductCategory-gl-pc-catset-electronics-base-devices-FullName",
        12414: "FS-ProductCategory-gl-computeraccessories-FullName",
        12406: "FS-ProductCategory-dvd-FullName",
        12434: "FS-ProductCategory-personalcareappliances-FullName",
        12426: "FS-ProductCategory-drugstore-FullName",
        12420: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        12430: "FS-ProductCategory-gl-major-appliances-catset-major-appliances-FullName",
        12427: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        12415: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        12419: "FS-ProductCategory-gl-electronicaccessories-FullName",
        12409: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        12408: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        12443: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        12416: "FS-ProductCategory-gl-sports-catset-bicycles-FullName",
        12421: "FS-ProductCategory-bissfluidtransfer-FullName",
        12441: "FS-ProductCategory-guild-FullName",
        12407: "FS-ProductCategory-biss-FullName",
        12428: "FS-ProductCategory-bissindustrialtools-FullName",
        12425: "FS-ProductCategory-grocery-FullName",
        12422: "FS-ProductCategory-foodandbeverage-FullName",
        12418: "FS-ProductCategory-bisseducationsupplies-FullName",
        12431: "FS-ProductCategory-bissmaterialhandling-FullName",
        12433: "FS-ProductCategory-musicalinstruments-FullName",
        12424: "FS-ProductCategory-furniture-FullName",
        12423: "FS-ProductCategory-furniture-mattresses-FullName",
        12403: "FS-ProductCategory-babyproduct-FullName",
        12432: "FS-ProductCategory-bissmetalworking-FullName",
        12429: "FS-ProductCategory-jewelry-FullName",
        12435: "FS-ProductCategory-gl-software-FullName",
        12436: "FS-ProductCategory-sports-FullName",
        12440: "FS-ProductCategory-watch-FullName",
        12438: "FS-ProductCategory-gl-videogames-FullName",
        12439: "FS-ProductCategory-videogames-consoles-au-FullName",
        12405: "FS-ProductCategory-wine-jp-FullName",
        12417: "FS-ProductCategory-tools-FullName",
        12402: "FS-ProductCategory-digitalaccessories-FullName",
    },
    "FR": {
        12718: "FS-ProductCategory-gl-electronicaccessories-FullName",
        12743: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        12714: "FS-ProductCategory-gl-computeraccessories-FullName",
        12702: "FS-ProductCategory-digitalaccessories-FullName",
        12709: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        12741: "FS-ProductCategory-guild-FullName",
        12708: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        12710: "FS-ProductCategory-automotive-FullName",
        12704: "FS-ProductCategory-beauty-FullName",
        12728: "FS-ProductCategory-jewelry-FullName",
        12739: "FS-ProductCategory-videogames-consoles-au-FullName",
        12719: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        12706: "FS-ProductCategory-dvd-FullName",
        12724: "FS-ProductCategory-grocery-FullName",
        12701: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        12717: "FS-ProductCategory-bisseducationsupplies-FullName",
        12726: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        12734: "FS-ProductCategory-biss-renewableenergysupplies-FullName",
        12729: "FS-ProductCategory-gl-major-appliances-catset-major-appliances-FullName",
        12707: "FS-ProductCategory-biss-FullName",
        12713: "FS-ProductCategory-gl-pc-catset-base-devices-FullName",
        12732: "FS-ProductCategory-musicalinstruments-FullName",
        12738: "FS-ProductCategory-gl-videogames-FullName",
        12735: "FS-ProductCategory-gl-software-FullName",
        12730: "FS-ProductCategory-bissmaterialhandling-FullName",
        12723: "FS-ProductCategory-furniture-FullName",
        12722: "FS-ProductCategory-furniture-mattresses-FullName",
        12740: "FS-ProductCategory-watch-FullName",
        12731: "FS-ProductCategory-bissmetalworking-FullName",
        12716: "FS-ProductCategory-tools-FullName",
        12727: "FS-ProductCategory-bissindustrialtools-FullName",
        12737: "FS-ProductCategory-gl-tires-FullName",
        12703: "FS-ProductCategory-babyproduct-FullName",
        12715: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        12733: "FS-ProductCategory-personalcareappliances-FullName",
        12736: "FS-ProductCategory-sports-FullName",
        12720: "FS-ProductCategory-bissfluidtransfer-FullName",
        12705: "FS-ProductCategory-wine-jp-FullName",
        12712: "FS-ProductCategory-apparel-FullName",
    },
    "IT": {
        13012: "FS-ProductCategory-apparel-FullName",
        13018: "FS-ProductCategory-gl-electronicaccessories-FullName",
        13009: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        13014: "FS-ProductCategory-gl-computeraccessories-FullName",
        13043: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        13002: "FS-ProductCategory-gl-digital-accessories-10-FullName",
        13024: "FS-ProductCategory-grocery-FullName",
        13041: "FS-ProductCategory-guild-FullName",
        13023: "FS-ProductCategory-furniture-FullName",
        13022: "FS-ProductCategory-furniture-mattresses-FullName",
        13010: "FS-ProductCategory-gl-carandmotorbike-FullName",
        13004: "FS-ProductCategory-beauty-FullName",
        13007: "FS-ProductCategory-biss-FullName",
        13039: "FS-ProductCategory-videogames-consoles-au-FullName",
        13019: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        13006: "FS-ProductCategory-dvd-FullName",
        13008: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        13015: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        13001: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        13016: "FS-ProductCategory-tools-FullName",
        13034: "FS-ProductCategory-biss-renewableenergysupplies-FullName",
        13028: "FS-ProductCategory-jewelry-FullName",
        13029: "FS-ProductCategory-gl-major-appliances-catset-major-appliances-FullName",
        13026: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        13013: "FS-ProductCategory-gl-pc-catset-base-devices-FullName",
        13031: "FS-ProductCategory-bissmetalworking-FullName",
        13017: "FS-ProductCategory-bisseducationsupplies-FullName",
        13040: "FS-ProductCategory-watch-FullName",
        13037: "FS-ProductCategory-gl-tires-FullName",
        13003: "FS-ProductCategory-babyproduct-FullName",
        13030: "FS-ProductCategory-bissmaterialhandling-FullName",
        13033: "FS-ProductCategory-personalcareappliances-FullName",
        13025: "FS-ProductCategory-drugstore-FullName",
        13035: "FS-ProductCategory-gl-software-FullName",
        13036: "FS-ProductCategory-sports-FullName",
        13027: "FS-ProductCategory-bissindustrialtools-FullName",
        13032: "FS-ProductCategory-musicalinstruments-FullName",
        13020: "FS-ProductCategory-bissfluidtransfer-FullName",
        13038: "FS-ProductCategory-gl-videogames-FullName",
        13005: "FS-ProductCategory-wine-jp-FullName",
    },
    "ES": {
        13309: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        13314: "FS-ProductCategory-gl-computeraccessories-FullName",
        13343: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        13302: "FS-ProductCategory-digitalaccessories-FullName",
        13304: "FS-ProductCategory-beauty-FullName",
        13337: "FS-ProductCategory-tires-FullName",
        13310: "FS-ProductCategory-automotive-FullName",
        13339: "FS-ProductCategory-videogames-consoles-au-FullName",
        13319: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        13306: "FS-ProductCategory-dvd-FullName",
        13336: "FS-ProductCategory-sports-FullName",
        13308: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        13315: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        13329: "FS-ProductCategory-gl-major-appliances-catset-major-appliances-FullName",
        13318: "FS-ProductCategory-electronics-FullName",
        13326: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        13301: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        13324: "FS-ProductCategory-grocery-FullName",
        13341: "FS-ProductCategory-guild-FullName",
        13327: "FS-ProductCategory-bissindustrialtools-FullName",
        13316: "FS-ProductCategory-tools-FullName",
        13307: "FS-ProductCategory-biss-FullName",
        13313: "FS-ProductCategory-gl-pc-catset-base-devices-FullName",
        13332: "FS-ProductCategory-musicalinstruments-FullName",
        13328: "FS-ProductCategory-jewelry-FullName",
        13330: "FS-ProductCategory-bissmaterialhandling-FullName",
        13317: "FS-ProductCategory-bisseducationsupplies-FullName",
        13322: "FS-ProductCategory-furniture-mattresses-FullName",
        13323: "FS-ProductCategory-furniture-FullName",
        13303: "FS-ProductCategory-babyproduct-FullName",
        13340: "FS-ProductCategory-watch-FullName",
        13312: "FS-ProductCategory-apparel-FullName",
        13333: "FS-ProductCategory-personalcareappliances-FullName",
        13325: "FS-ProductCategory-drugstore-FullName",
        13331: "FS-ProductCategory-bissmetalworking-FullName",
        13335: "FS-ProductCategory-gl-software-FullName",
        13334: "FS-ProductCategory-biss-renewableenergysupplies-FullName",
        13320: "FS-ProductCategory-bissfluidtransfer-FullName",
        13338: "FS-ProductCategory-gl-videogames-FullName",
        13305: "FS-ProductCategory-wine-jp-FullName",
    },
    "NL": {
        13602: "FS-ProductCategory-gl-digital-accessories-10-FullName",
        13601: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        13609: "FS-ProductCategory-automotive-FullName",
        13603: "FS-ProductCategory-babyproduct-FullName",
        13635: "FS-ProductCategory-gl-automotive-catset-tires-FullName",
        13612: "FS-ProductCategory-gl-pc-catset-electronics-base-devices-FullName",
        13614: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        13605: "FS-ProductCategory-dvd-FullName",
        13618: "FS-ProductCategory-electronics-FullName",
        13608: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        13607: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        13632: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        13615: "FS-ProductCategory-gl-sports-catset-bicycles-FullName",
        13628: "FS-ProductCategory-videogames-consoles-au-FullName",
        13623: "FS-ProductCategory-grocery-FullName",
        13624: "FS-ProductCategory-personalcareappliances-FullName",
        13629: "FS-ProductCategory-watch-FullName",
        13606: "FS-ProductCategory-biss-FullName",
        13616: "FS-ProductCategory-bissindustrialtools-FullName",
        13611: "FS-ProductCategory-apparel-FullName",
        13622: "FS-ProductCategory-furniture-FullName",
        13621: "FS-ProductCategory-gl-furniture-catset-mattress-FullName",
        13634: "FS-ProductCategory-musicalinstruments-FullName",
        13617: "FS-ProductCategory-bisseducationsupplies-FullName",
        13613: "FS-ProductCategory-pc-FullName",
        13604: "FS-ProductCategory-beauty-FullName",
        13633: "FS-ProductCategory-jewelry-FullName",
        13627: "FS-ProductCategory-videogames-FullName",
        13625: "FS-ProductCategory-software-FullName",
        13626: "FS-ProductCategory-gl-sports-outdoors-FullName",
        13619: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        13620: "FS-ProductCategory-bissfluidtransfer-FullName",
        13631: "FS-ProductCategory-wine-jp-FullName",
    },
    "TR": {
        13908: "FS-ProductCategory-homeimprovement-FullName",
        13915: "FS-ProductCategory-gl_shoes-FullName",
        13912: "FS-ProductCategory-babyproduct-FullName",
        13904: "FS-ProductCategory-pc-FullName",
        13905: "FS-ProductCategory-electronics-FullName",
        13906: "FS-ProductCategory-gl-electronics-catset-electronics-accessories-FullName",
        13901: "FS-ProductCategory-camera-FullName",
        13903: "FS-ProductCategory-gl_apparel-FullName",
        13902: "FS-ProductCategory-wireless-FullName",
        13911: "FS-ProductCategory-book-FullName",
        13909: "FS-ProductCategory-kitchen-homeappliances-jp-FullName",
        13913: "FS-ProductCategory-officeproduct-FullName",
        13910: "FS-ProductCategory-toy-FullName",
        13917: "FS-ProductCategory-gl_drugstore-FullName",
        13907: "FS-ProductCategory-personalcareappliances-FullName",
        13914: "FS-ProductCategory-sports-FullName",
    },
    "AE": {
        14202: "FS-ProductCategory-automotive-FullName",
        14203: "FS-ProductCategory-babyproduct-FullName",
        14204: "FS-ProductCategory-beauty-FullName",
        14205: "FS-ProductCategory-book-FullName",
        14206: "FS-ProductCategory-camera-FullName",
        14201: "FS-ProductCategory-apparel-FullName",
        14234: "FS-ProductCategory-dvd-FullName",
        14207: "FS-ProductCategory-electronics-FullName",
        14208: "FS-ProductCategory-gl-electronics-catset-electronics-accessories-FullName",
        14209: "FS-ProductCategory-furniture-FullName",
        14210: "FS-ProductCategory-giftcard-FullName",
        14211: "FS-ProductCategory-grocery-FullName",
        14226: "FS-ProductCategory-personalcareappliances-FullName",
        14212: "FS-ProductCategory-drugstore-FullName",
        14213: "FS-ProductCategory-gl-home-FullName",
        14214: "FS-ProductCategory-jewelry-FullName",
        14215: "FS-ProductCategory-kitchen-FullName",
        14216: "FS-ProductCategory-luggage-FullName",
        14217: "FS-ProductCategory-majorappliances-FullName",
        14218: "FS-ProductCategory-gl-wireless-catset-wireless-base-devices-FullName",
        14219: "FS-ProductCategory-music-FullName",
        14221: "FS-ProductCategory-musicalinstruments-FullName",
        14222: "FS-ProductCategory-officeproduct-FullName",
        14223: "FS-ProductCategory-outdoors-FullName",
        14225: "FS-ProductCategory-gl-beauty-catset-perfumes-FullName",
        14224: "FS-ProductCategory-gl-pc-store-FullName",
        14227: "FS-ProductCategory-gl-petsupplies-FullName",
        14228: "FS-ProductCategory-shoes-FullName",
        14229: "FS-ProductCategory-gl-major-appliances-smallappliance-FullName",
        14236: "FS-ProductCategory-videogames-FullName",
        14230: "FS-ProductCategory-sports-FullName",
        14231: "FS-ProductCategory-gl-stamps-collectibles-FullName",
        14232: "FS-ProductCategory-tools-FullName",
        14233: "FS-ProductCategory-toy-FullName",
        14235: "FS-ProductCategory-videogames-consoles-au-FullName",
        14237: "FS-ProductCategory-watch-FullName",
    },
    "SA": {
        14503: "FS-ProductCategory-automotive-FullName",
        14504: "FS-ProductCategory-babyproduct-FullName",
        14506: "FS-ProductCategory-beauty-FullName",
        14507: "FS-ProductCategory-book-FullName",
        14509: "FS-ProductCategory-camera-FullName",
        14501: "FS-ProductCategory-apparel-FullName",
        14541: "FS-ProductCategory-dvd-FullName",
        14510: "FS-ProductCategory-electronics-FullName",
        14512: "FS-ProductCategory-gl-electronics-catset-electronics-accessories-FullName",
        14513: "FS-ProductCategory-furniture-FullName",
        14514: "FS-ProductCategory-giftcard-FullName",
        14515: "FS-ProductCategory-grocery-FullName",
        14531: "FS-ProductCategory-personalcareappliances-FullName",
        14517: "FS-ProductCategory-drugstore-FullName",
        14518: "FS-ProductCategory-gl-home-FullName",
        14519: "FS-ProductCategory-jewelry-FullName",
        14521: "FS-ProductCategory-kitchen-FullName",
        14522: "FS-ProductCategory-luggage-FullName",
        14523: "FS-ProductCategory-majorappliances-FullName",
        14524: "FS-ProductCategory-gl-wireless-catset-wireless-base-devices-FullName",
        14525: "FS-ProductCategory-music-FullName",
        14526: "FS-ProductCategory-musicalinstruments-FullName",
        14527: "FS-ProductCategory-officeproduct-FullName",
        14528: "FS-ProductCategory-outdoors-FullName",
        14530: "FS-ProductCategory-gl-beauty-catset-perfumes-FullName",
        14529: "FS-ProductCategory-gl-pc-store-FullName",
        14532: "FS-ProductCategory-gl-petsupplies-FullName",
        14534: "FS-ProductCategory-shoes-FullName",
        14535: "FS-ProductCategory-gl-major-appliances-catset-small-appliances-FullName",
        14543: "FS-ProductCategory-videogames-FullName",
        14536: "FS-ProductCategory-sports-FullName",
        14537: "FS-ProductCategory-gl-stamps-collectibles-FullName",
        14539: "FS-ProductCategory-tools-FullName",
        14540: "FS-ProductCategory-toy-FullName",
        14542: "FS-ProductCategory-gl-video-games-catset-video-game-console-FullName",
        14544: "FS-ProductCategory-gl-watches-FullName",
        14545: "FS-ProductCategory-wireless-FullName",
        14533: "FS-ProductCategory-gl-wireless-catset-portable-audio-FullName",
    },
    "SE": {
        14834: "FS-ProductCategory-gl-automotive-catset-tires-FullName",
        14801: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        14802: "FS-ProductCategory-digitalaccessories-FullName",
        14803: "FS-ProductCategory-babyproduct-FullName",
        14809: "FS-ProductCategory-automotive-FullName",
        14805: "FS-ProductCategory-gl-DVD-FullName",
        14839: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        14812: "FS-ProductCategory-gl-pc-catset-electronics-base-devices-FullName",
        14807: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        14808: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        14818: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        14822: "FS-ProductCategory-grocery-FullName",
        14824: "FS-ProductCategory-home-FullName",
        14823: "FS-ProductCategory-drugstore-FullName",
        14825: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        14806: "FS-ProductCategory-biss-FullName",
        14815: "FS-ProductCategory-bissindustrialtools-FullName",
        14811: "FS-ProductCategory-apparel-FullName",
        14837: "FS-ProductCategory-watch-FullName",
        14817: "FS-ProductCategory-electronics-FullName",
        14828: "FS-ProductCategory-bissmaterialhandling-FullName",
        14829: "FS-ProductCategory-bissmetalworking-FullName",
        14830: "FS-ProductCategory-musicalinstruments-FullName",
        14821: "FS-ProductCategory-furniture-FullName",
        14820: "FS-ProductCategory-gl-furniture-catset-mattress-FullName",
        14816: "FS-ProductCategory-bisseducationsupplies-FullName",
        14832: "FS-ProductCategory-software-FullName",
        14804: "FS-ProductCategory-beauty-FullName",
        14827: "FS-ProductCategory-jewelry-FullName",
        14836: "FS-ProductCategory-videogames-consoles-au-FullName",
        14833: "FS-ProductCategory-gl-sports-outdoors-FullName",
        14819: "FS-ProductCategory-bissfluidtransfer-FullName",
    },
    "PL": {
        15102: "FS-ProductCategory-digitalaccessories-FullName",
        15118: "FS-ProductCategory-gl-electronicaccessories-FullName",
        15108: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        15113: "FS-ProductCategory-gl-computeraccessories-FullName",
        15142: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        15139: "FS-ProductCategory-officeproduct-FullName",
        15117: "FS-ProductCategory-bisseducationsupplies-FullName",
        15106: "FS-ProductCategory-biss-FullName",
        15138: "FS-ProductCategory-luggage-FullName",
        15125: "FS-ProductCategory-jewelry-FullName",
        15122: "FS-ProductCategory-gl-home-FullName",
        15101: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        15114: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        15123: "FS-ProductCategory-bissindustrialelectricalsupplies-FullName",
        15133: "FS-ProductCategory-gl-videogames-FullName",
        15128: "FS-ProductCategory-musicalinstruments-FullName",
        15112: "FS-ProductCategory-gl-pc-catset-electronics-base-devices-FullName",
        15134: "FS-ProductCategory-videogames-consoles-au-FullName",
        15119: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        15105: "FS-ProductCategory-book-FullName",
        15109: "FS-ProductCategory-automotive-FullName",
        15143: "FS-ProductCategory-music-FullName",
        15124: "FS-ProductCategory-bissindustrialtools-FullName",
        15127: "FS-ProductCategory-bissmetalworking-FullName",
        15126: "FS-ProductCategory-bissmaterialhandling-FullName",
        15111: "FS-ProductCategory-apparel-FullName",
        15137: "FS-ProductCategory-gl-lawnandgarden-FullName",
        15132: "FS-ProductCategory-gl-automotive-catset-tires-FullName",
        15130: "FS-ProductCategory-gl-software-FullName",
        15103: "FS-ProductCategory-babyproduct-FullName",
        15140: "FS-ProductCategory-gl-petsupplies-FullName",
        15131: "FS-ProductCategory-gl-sports-outdoors-FullName",
        15115: "FS-ProductCategory-gl-sports-catset-bicycles-FullName",
        15120: "FS-ProductCategory-bissfluidtransfer-FullName",
        15104: "FS-ProductCategory-beauty-FullName",
        15129: "FS-ProductCategory-gl-personalcareappliances-FullName",
        15107: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        15141: "FS-ProductCategory-toy-FullName",
        15121: "FS-ProductCategory-gl-healthandpersonalcare-FullName",
        15135: "FS-ProductCategory-watch-FullName",
    },
    "IN": {
        15533: "FS-ProductCategory-pc-pcaccessories-in-FullName",
        15488: "FS-ProductCategory-digitalaccessories2-FullName",
        15430: "FS-ProductCategory-apparel-FullName",
        15433: "FS-ProductCategory-apparel-apparelaccessories-in-FullName",
        15477: "FS-ProductCategory-automotive-FullName",
        15420: "FS-ProductCategory-babyproduct-FullName",
        15410: "FS-ProductCategory-beauty-FullName",
        15401: "FS-ProductCategory-book-FullName",
        15531: "FS-ProductCategory-pc-datacables-in-FullName",
        15521: "FS-ProductCategory-electronics-cameraaccessories-in-FullName",
        15520: "FS-ProductCategory-electronics-cameralenses-in-FullName",
        15530: "FS-ProductCategory-gl-electronics-catset-car-cradles-lenskits-and-foliocases-FullName",
        15500: "FS-ProductCategory-electronics-car-electronics-in-FullName",
        15528: "FS-ProductCategory-pc-casescoversandskins-in-FullName",
        15505: "FS-ProductCategory-electronics-desktops-in-FullName",
        15522: "FS-ProductCategory-wirelessaccessory-gps-devices-in-FullName",
        15524: "FS-ProductCategory-electronics-headphones-earphones-in-FullName",
        15525: "FS-ProductCategory-electronics-keyboards-mouse-in-FullName",
        15516: "FS-ProductCategory-gl-wireless-accessory-catset-landlinephones-FullName",
        15508: "FS-ProductCategory-electronics-laptopbags-in-FullName",
        15507: "FS-ProductCategory-electronics-laptopbattery-in-FullName",
        15512: "FS-ProductCategory-electronics-memorycards-in-FullName",
        15513: "FS-ProductCategory-electronics-modemandnetworkingdevices-in-FullName",
        15506: "FS-ProductCategory-electronics-monitors-in-FullName",
        15527: "FS-ProductCategory-gl-musical-instruments-catset-musical-instruments-proaudio-FullName",
        15534: "FS-ProductCategory-musicalinstruments-guitars-in-FullName",
        15535: "FS-ProductCategory-musicalinstruments-keyboards-in-FullName",
        15503: "FS-ProductCategory-gl-pc-catset-office-products-electronics-FullName",
        15526: "FS-ProductCategory-electronics-powerbanks-in-FullName",
        15499: "FS-ProductCategory-electronics-pcdevices-in-FullName",
        15517: "FS-ProductCategory-gl-wireless-accessory-catset-smart-watches-FullName",
        15523: "FS-ProductCategory-electronics-speakers-in-FullName",
        15518: "FS-ProductCategory-gl-electronics-catset-tv-FullName",
        15509: "FS-ProductCategory-electronics-usbflashdrive-in-FullName",
        15537: "FS-ProductCategory-wirelessaccessory-ce-warranty-in-FullName",
        15498: "FS-ProductCategory-coinscollectibles-FullName",
        15447: "FS-ProductCategory-gl-baby-product-catset-hardlines-FullName",
        15411: "FS-ProductCategory-beauty-fragrance-in-FullName",
        15416: "FS-ProductCategory-drugstore-household-supplies-in-FullName",
        15414: "FS-ProductCategory-drugstore-medicalequipment-in-FullName",
        15415: "FS-ProductCategory-drugstore-nutrition-in-FullName",
        15417: "FS-ProductCategory-personalcareappliances-pca-grooming-and-styling-FullName",
        15419: "FS-ProductCategory-gl-personal-care-appliances-catset-pcamassagers-FullName",
        15429: "FS-ProductCategory-gl-toy-catset-toysdrones-FullName",
        15491: "FS-ProductCategory-gl-sports-catset-bicycles-FullName",
        15502: "FS-ProductCategory-electronics-electronicsdevices-in-FullName",
        15501: "FS-ProductCategory-electronics-cestorage-in-FullName",
        15497: "FS-ProductCategory-entertainmentcollectibles-FullName",
        15436: "FS-ProductCategory-apparel-eyewear-in-FullName",
        15514: "FS-ProductCategory-jewelry-FullName",
        15421: "FS-ProductCategory-art-FullName",
        15486: "FS-ProductCategory-furniture-FullName",
        15495: "FS-ProductCategory-consumablesphysicalgiftcards-FullName",
        15426: "FS-ProductCategory-grocery-FullName",
        15441: "FS-ProductCategory-shoes-handbags-in-FullName",
        15418: "FS-ProductCategory-personalcareappliances-FullName",
        15413: "FS-ProductCategory-drugstore-FullName",
        15465: "FS-ProductCategory-home-FullName",
        15462: "FS-ProductCategory-homeimprovement-FullName",
        15471: "FS-ProductCategory-lawnandgarden-FullName",
        15460: "FS-ProductCategory-biss-FullName",
        15434: "FS-ProductCategory-apparel-innerwear-in-FullName",
        15453: "FS-ProductCategory-kitchen-FullName",
        15484: "FS-ProductCategory-majorappliances-FullName",
        15446: "FS-ProductCategory-luggage-FullName",
        15412: "FS-ProductCategory-luxurybeauty-FullName",
        15406: "FS-ProductCategory-videogames-videogameaccessories-in-FullName",
        15405: "FS-ProductCategory-videogames-videogameconsoles-us-FullName",
        15407: "FS-ProductCategory-gl-video-games-catset-onlinegames-FullName",
        15536: "FS-ProductCategory-dvd-FullName",
        15403: "FS-ProductCategory-music-FullName",
        15515: "FS-ProductCategory-musicalinstruments-FullName",
        15532: "FS-ProductCategory-officeproduct-FullName",
        15479: "FS-ProductCategory-automotive-helmetslubricantspartscare-in-FullName",
        15480: "FS-ProductCategory-automotive-accessories-in-FullName",
        15481: "FS-ProductCategory-automotive-carsbikes-in-FullName",
        15490: "FS-ProductCategory-gl-biss-catset-food-equipment-material-handling-professional-cleaning-medical-and-heal-FullName",
        15487: "FS-ProductCategory-furniture-beanbags-inflatables-in-FullName",
        15511: "FS-ProductCategory-home-bedandbath-in-FullName",
        15476: "FS-ProductCategory-home-clocks-in-FullName",
        15467: "FS-ProductCategory-home-craftmaterials-in-FullName",
        15454: "FS-ProductCategory-gl-kitchen-catset-gas-stoves-and-pressure-cookers-FullName",
        15455: "FS-ProductCategory-gl-kitchen-catset-glassware-and-ceramicware-FullName",
        15492: "FS-ProductCategory-gym-equipments-in-FullName",
        15510: "FS-ProductCategory-gl-home-catset-barbagebins-FullName",
        15458: "FS-ProductCategory-gl-home-catset-fragrance-and-candles-FullName",
        15459: "FS-ProductCategory-home-home-furnishing-FullName",
        15461: "FS-ProductCategory-homeimprovement-hi-accessories-FullName",
        15464: "FS-ProductCategory-gl-home-catset-home-storage-FullName",
        15475: "FS-ProductCategory-home-indoorlighting-in-FullName",
        15473: "FS-ProductCategory-gl-home-instruments-catset-indoor-lighting-wall-and-ceiling-fixture-lights-FullName",
        15474: "FS-ProductCategory-home-ledbulbs-in-FullName",
        15466: "FS-ProductCategory-biss-scientific-supplies-in-FullName",
        15463: "FS-ProductCategory-gl-home-improvement-catset-ladders-home-security-systems-kitchen-and-bath-fixtures-FullName",
        15469: "FS-ProductCategory-lawnandgarden-chemical-pest-control-in-FullName",
        15470: "FS-ProductCategory-gl-lawn-and-garden-catset-lawn-and-graden-outdoor-FullName",
        15472: "FS-ProductCategory-gl-lawn-and-garden-catset-plants-seeds-bulbs-FullName",
        15468: "FS-ProductCategory-lawnandgarden-solar-devices-in-FullName",
        15483: "FS-ProductCategory-majorappliances-chimneys-in-FullName",
        15485: "FS-ProductCategory-gl-major-appliances-catset-refrigerators-FullName",
        15482: "FS-ProductCategory-majorappliances-la-accessories-in-FullName",
        15402: "FS-ProductCategory-gl-apparel-catset-masksppe-FullName",
        15493: "FS-ProductCategory-sports-cricket-and-badminton-equipments-FullName",
        15457: "FS-ProductCategory-gl-home-catset-wall-art-FullName",
        15504: "FS-ProductCategory-electronics-pccomponents-in-FullName",
        15489: "FS-ProductCategory-pc-pcs-in-FullName",
        15409: "FS-ProductCategory-petproducts-FullName",
        15427: "FS-ProductCategory-prescriptiondrugs-FullName",
        15438: "FS-ProductCategory-shoes-FullName",
        15435: "FS-ProductCategory-apparel-sleepwear-in-FullName",
        15456: "FS-ProductCategory-kitchen-smallappliances-in-FullName",
        15432: "FS-ProductCategory-gl-apparel-catset-menstshirts-FullName",
        15431: "FS-ProductCategory-gl-apparel-catset-sarees-and-dress-materials-FullName",
        15443: "FS-ProductCategory-shoes-backpacks-in-FullName",
        15452: "FS-ProductCategory-jewelry-finegoldcoins-in-FullName",
        15451: "FS-ProductCategory-jewelry-finestuddedjewelry-in-FullName",
        15450: "FS-ProductCategory-jewelry-finesolitairejewelry-in-FullName",
        15439: "FS-ProductCategory-shoes-open-footwear-FullName",
        15440: "FS-ProductCategory-gl-shoes-catset-kid-shoes-FullName",
        15444: "FS-ProductCategory-lugagge-suitcase-and-trolleys-FullName",
        15445: "FS-ProductCategory-luggage-travel-accessories-FullName",
        15449: "FS-ProductCategory-jewelry-silver-coins-FullName",
        15448: "FS-ProductCategory-gl-jewelry-catset-fine-silver-jewelry-FullName",
        15442: "FS-ProductCategory-gl-luggage-catset-wallets-FullName",
        15408: "FS-ProductCategory-software-FullName",
        15494: "FS-ProductCategory-sports-FullName",
        15496: "FS-ProductCategory-sportsmemorabilia-FullName",
        15529: "FS-ProductCategory-pc-cetablets-in-FullName",
        15428: "FS-ProductCategory-toy-FullName",
        15478: "FS-ProductCategory-gl-automotive-catset-tires-FullName",
        15404: "FS-ProductCategory-videogames-FullName",
        15437: "FS-ProductCategory-watch-FullName",
    },
    "EG": {
        15718: "FS-ProductCategory-automotive-FullName",
        15711: "FS-ProductCategory-babyproduct-FullName",
        15712: "FS-ProductCategory-beauty-FullName",
        15729: "FS-ProductCategory-book-FullName",
        15701: "FS-ProductCategory-camera-FullName",
        15735: "FS-ProductCategory-apparel-FullName",
        15730: "FS-ProductCategory-dvd-FullName",
        15702: "FS-ProductCategory-electronics-FullName",
        15704: "FS-ProductCategory-gl-electronics-catset-electronics-accessories-FullName",
        15719: "FS-ProductCategory-furniture-FullName",
        15731: "FS-ProductCategory-giftcard-FullName",
        15713: "FS-ProductCategory-grocery-FullName",
        15716: "FS-ProductCategory-personalcareappliances-FullName",
        15714: "FS-ProductCategory-drugstore-FullName",
        15720: "FS-ProductCategory-gl-home-FullName",
        15736: "FS-ProductCategory-jewelry-FullName",
        15721: "FS-ProductCategory-kitchen-FullName",
        15737: "FS-ProductCategory-luggage-FullName",
        15722: "FS-ProductCategory-majorappliances-FullName",
        15705: "FS-ProductCategory-gl-wireless-catset-wireless-base-devices-FullName",
        15732: "FS-ProductCategory-music-FullName",
        15706: "FS-ProductCategory-musicalinstruments-FullName",
        15707: "FS-ProductCategory-officeproduct-FullName",
        15723: "FS-ProductCategory-outdoors-FullName",
        15715: "FS-ProductCategory-gl-beauty-catset-perfumes-FullName",
        15708: "FS-ProductCategory-gl-pc-store-FullName",
        15717: "FS-ProductCategory-gl-petsupplies-FullName",
        15738: "FS-ProductCategory-shoes-FullName",
        15724: "FS-ProductCategory-gl-major-appliances-smallappliance-FullName",
        15734: "FS-ProductCategory-videogames-FullName",
        15725: "FS-ProductCategory-sports-FullName",
        15726: "FS-ProductCategory-gl-stamps-collectibles-FullName",
        15703: "FS-ProductCategory-gl-electronics-catset-televisions-FullName",
        15727: "FS-ProductCategory-tools-FullName",
        15728: "FS-ProductCategory-toy-FullName",
        15733: "FS-ProductCategory-videogames-consoles-au-FullName",
        15739: "FS-ProductCategory-watch-FullName",
        15710: "FS-ProductCategory-gl-wireless-catset-portable-audio-FullName",
    },
    "BE": {
        16001: "FS-ProductCategory-bissadditivemanufacturing-FullName",
        16002: "FS-ProductCategory-digitalaccessories-FullName",
        16003: "FS-ProductCategory-babyproduct-FullName",
        16004: "FS-ProductCategory-beauty-FullName",
        16005: "FS-ProductCategory-wine-jp-FullName",
        16006: "FS-ProductCategory-dvd-FullName",
        16007: "FS-ProductCategory-biss-FullName",
        16008: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-devices-FullName",
        16009: "FS-ProductCategory-gl-automotive-catset-vehicle-electronics-accessories-FullName",
        16010: "FS-ProductCategory-automotive-FullName",
        16011: "FS-ProductCategory-apparel-FullName",
        16012: "FS-ProductCategory-gl-pc-catset-electronics-base-devices-FullName",
        16013: "FS-ProductCategory-pc-FullName",
        16014: "FS-ProductCategory-electronics-FullName",
        16015: "FS-ProductCategory-gl-electronics-catset-base-devices-FullName",
        16016: "FS-ProductCategory-gl-sports-catset-bicycles-FullName",
        16017: "FS-ProductCategory-gl-sports-catset-cycling-accessories-FullName",
        16018: "FS-ProductCategory-homeimprovement-FullName",
        16019: "FS-ProductCategory-bisseducationsupplies-FullName",
        16020: "FS-ProductCategory-bissflowcontrolandfiltration-FullName",
        16021: "FS-ProductCategory-bissfluidtransfer-FullName",
        16022: "FS-ProductCategory-furniture-FullName",
        16023: "FS-ProductCategory-grocery-FullName",
        16024: "FS-ProductCategory-jewelry-FullName",
        16025: "FS-ProductCategory-musicalinstruments-FullName",
        16026: "FS-ProductCategory-gl-furniture-catset-mattress-FullName",
        16027: "FS-ProductCategory-personalcareappliances-FullName",
        16028: "FS-ProductCategory-software-FullName",
        16029: "FS-ProductCategory-gl-sports-outdoors-FullName",
        16030: "FS-ProductCategory-gl-automotive-catset-tires-FullName",
        16031: "FS-ProductCategory-videogames-FullName",
        16032: "FS-ProductCategory-videogames-consoles-au-FullName",
        16033: "FS-ProductCategory-gl-watches-FullName",
        16034: "FS-ProductCategory-default-FullName",
    },
    "JP": {
        11202: "FS-ProductCategory-music-FullName",
        11228: "FS-ProductCategory-homeimprovement-FullName",
        11203: "FS-ProductCategory-gl-dvd-FullName",
        11209: "FS-ProductCategory-digitalaccessories-FullName",
        11219: "FS-ProductCategory-software-FullName",
        11218: "FS-ProductCategory-videogames-FullName",
        11217: "FS-ProductCategory-videogame-hardware-jp-FullName",
        11216: "FS-ProductCategory-toy-FullName",
        11205: "FS-ProductCategory-electronics-FullName",
        11208: "FS-ProductCategory-electronics-accessories-jp-FullName",
        11206: "FS-ProductCategory-camera-FullName",
        11215: "FS-ProductCategory-automotive-FullName",
        11237: "FS-ProductCategory-shoes-FullName",
        11233: "FS-ProductCategory-jewelry-FullName",
        11214: "FS-ProductCategory-sports-FullName",
        11207: "FS-ProductCategory-pc-FullName",
        11204: "FS-ProductCategory-gl-video-FullName",
        11212: "FS-ProductCategory-beauty-FullName",
        11211: "FS-ProductCategory-drugstore-FullName",
        11234: "FS-ProductCategory-babyproduct-FullName",
        11220: "FS-ProductCategory-petproducts-FullName",
        11226: "FS-ProductCategory-home-FullName",
        11224: "FS-ProductCategory-kitchen-FullName",
        11223: "FS-ProductCategory-kitchen-homeappliances-jp-FullName",
        11213: "FS-ProductCategory-luxurybeauty-FullName",
        11227: "FS-ProductCategory-majorappliances-FullName",
        11225: "FS-ProductCategory-furniture-FullName",
        11222: "FS-ProductCategory-officeproduct-FullName",
        11232: "FS-ProductCategory-watch-FullName",
        11236: "FS-ProductCategory-apparel-FullName",
        11201: "FS-ProductCategory-book-FullName",
        11210: "FS-ProductCategory-musicalinstruments-FullName",
        11229: "FS-ProductCategory-biss-FullName",
        11231: "FS-ProductCategory-grocery-FullName",
        11230: "FS-ProductCategory-grocery-beer-jp-FullName",
    },
    "AU": {
        11501: "FS-ProductCategory-automotive-FullName",
        11504: "FS-ProductCategory-babyproduct-FullName",
        11503: "FS-ProductCategory-beauty-FullName",
        11502: "FS-ProductCategory-book-FullName",
        11505: "FS-ProductCategory-gl-camera-base-devices-FullName",
        11507: "FS-ProductCategory-apparel-FullName",
        11521: "FS-ProductCategory-pc-FullName",
        11506: "FS-ProductCategory-gl-electronics-au-base-devices-FullName",
        11530: "FS-ProductCategory-dvd-FullName",
        11508: "FS-ProductCategory-electronics-FullName",
        11522: "FS-ProductCategory-grocery-FullName",
        11510: "FS-ProductCategory-personalcareappliances-FullName",
        11509: "FS-ProductCategory-gl-home-FullName",
        11511: "FS-ProductCategory-jewelry-FullName",
        11512: "FS-ProductCategory-kitchen-FullName",
        11514: "FS-ProductCategory-gl-lawnandgarden-FullName",
        11513: "FS-ProductCategory-luggage-FullName",
        11515: "FS-ProductCategory-majorappliances-FullName",
        11517: "FS-ProductCategory-gl-wireless-wireless-handsets-FullName",
        11518: "FS-ProductCategory-music-FullName",
        11516: "FS-ProductCategory-musicalinstruments-FullName",
        11520: "FS-ProductCategory-officeproduct-FullName",
        11519: "FS-ProductCategory-outdoors-FullName",
        11523: "FS-ProductCategory-gl-petsupplies-FullName",
        11524: "FS-ProductCategory-shoes-FullName",
        11526: "FS-ProductCategory-gl-software-FullName",
        11525: "FS-ProductCategory-sports-FullName",
        11527: "FS-ProductCategory-tools-FullName",
        11528: "FS-ProductCategory-toy-FullName",
        11531: "FS-ProductCategory-videogames-consoles-au-FullName",
        11529: "FS-ProductCategory-gl-videogames-FullName",
    },
    "SG": {
        11801: "FS-ProductCategory-automotive-FullName",
        11802: "FS-ProductCategory-babyproduct-FullName",
        11803: "FS-ProductCategory-beauty-FullName",
        11804: "FS-ProductCategory-gl-books-FullName",
        11806: "FS-ProductCategory-camera-FullName",
        11808: "FS-ProductCategory-gl-electronic-catset-consumer-electronics-FullName",
        11809: "FS-ProductCategory-dvd-FullName",
        11810: "FS-ProductCategory-gl-electronic-accessories-FullName",
        11811: "FS-ProductCategory-furniture-FullName",
        11812: "FS-ProductCategory-grocery-FullName",
        11813: "FS-ProductCategory-personalcareappliances-FullName",
        11814: "FS-ProductCategory-gl-home-FullName",
        11815: "FS-ProductCategory-gl-homeimprovement-FullName",
        11816: "FS-ProductCategory-biss-FullName",
        11817: "FS-ProductCategory-jewelry-FullName",
        11818: "FS-ProductCategory-kitchen-FullName",
        11819: "FS-ProductCategory-lawnandgarden-FullName",
        11820: "FS-ProductCategory-luggage-FullName",
        11822: "FS-ProductCategory-music-FullName",
        11821: "FS-ProductCategory-musicalinstruments-FullName",
        11823: "FS-ProductCategory-officeproduct-FullName",
        11824: "FS-ProductCategory-outdoors-FullName",
        11825: "FS-ProductCategory-gl-pc-catset-devices-FullName",
        11826: "FS-ProductCategory-gl-petsupplies-FullName",
        11827: "FS-ProductCategory-software-FullName",
        11828: "FS-ProductCategory-sports-FullName",
        11829: "FS-ProductCategory-gl-tools-FullName",
        11830: "FS-ProductCategory-toy-FullName",
        11832: "FS-ProductCategory-videogames-consoles-au-FullName",
        11833: "FS-ProductCategory-watch-FullName",
        11805: "FS-ProductCategory-wine-jp-FullName",
        11807: "FS-ProductCategory-wireless-FullName",
    }
};

const defaultCategoryTRexIdMap = countryCategoryTRexIdMap["US"];

export const countryDefaultCategoryTRexIdMap: Record<string, number> = {
    "US": 10028,
    "CA": 10326,
    "MX": 10621,
    "BR": 10935,
    "GB": 12143,
    "DE": 12442,
    "FR": 12742,
    "IT": 13042,
    "ES": 13342,
    "NL": 13630,
    "TR": 13922,
    "AE": 14238,
    "SA": 14546,
    "SE": 14838,
    "PL": 15136,
    "IN": 15538,
    "EG": 15740,
    "JP": 11238,
    "AU": 11532,
    "SG": 11834
};


export function getCategoryTRexIdMapConfig(countryCode: string): Record<number, string> {
    return get(countryCategoryTRexIdMap, countryCode, defaultCategoryTRexIdMap);
}

export const weightUnitList: string[] = [
    "pounds",
    "kilograms"
]

export const dimensionUnitList: string[] = [
    "centimeters",
    "inches"
]

export const defaultCountryCode = "US";

export const IndiaSpecialFeeCategoryTRexIdMap: Record<string, string> = {
    "Apparel Accessories": "15433",
    "Innerwear": "15434",
    "Eyewear": "15436",
    "Sleepwear": "15435",
    "Handbags": "15441",
    "Small Appliances": "15456",
    "Electronics Storage Devices": "15501",
    "Electronic Devices": "15502",
    "PC components": "15504",
    "Tablets": "15529"
}